import { Stack } from "@biblioteksentralen/react";
import { Library } from "@libry-content/types";
import { withErrorBoundary } from "../errorPages/withErrorBoundary";
import { useCommonData } from "../layout/CommonDataProvider";
import OpeningHoursTable from "./OpeningHoursTable";
import SpecialOpeningHoursList from "./SpecialOpeningHoursList/SpecialOpeningHoursList";
import { OpeningHoursHelper } from "./openingHoursHelper/openingHoursHelper";

interface Props {
  library: Library;
}

export const LibraryOpeningHours = ({ library }: Props) => {
  const { site } = useCommonData();

  const openingHoursHelper = new OpeningHoursHelper(site, library);

  return (
    <Stack direction="column" spacing="1.5rem" as="section" minWidth="12rem">
      <OpeningHoursTable openingHoursHelper={openingHoursHelper} />
      <SpecialOpeningHoursList openingHoursHelper={openingHoursHelper} />
    </Stack>
  );
};

export default withErrorBoundary(LibraryOpeningHours, "LibraryOpeningHours");
